import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { getManagerDependingVariables } from "@devowl-wp/cookie-consent-web-client";
import { useFormService } from "../../../../../contexts/formService.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { LearnMoreTag } from "../../../../common/learnMoreTag.js";
import { Notices } from "../../../../common/notices.js";
const FormServiceFieldHandlingTagManagerEventName = ()=>{
    const { __ } = useI18n();
    const { setCookiesViaManager, createdTagManagers, isGcm, template } = useFormService();
    const { managerLabel, features, expectedManagerPresetId } = getManagerDependingVariables(setCookiesViaManager, {
        isGcm,
        presetId: template?.identifier
    });
    return features.events && /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Event names for %s", managerLabel),
        required: true,
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "tagManagerOptInEventName",
                noStyle: true,
                children: /*#__PURE__*/ _jsx(Input, {
                    addonBefore: __("Opt-in"),
                    style: {
                        maxWidth: 400,
                        marginRight: 10,
                        marginBottom: 5
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "tagManagerOptOutEventName",
                noStyle: true,
                children: /*#__PURE__*/ _jsx(Input, {
                    addonBefore: __("Opt-out"),
                    style: {
                        maxWidth: 400,
                        marginRight: 10,
                        marginBottom: 5
                    }
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: /*#__PURE__*/ _jsx(LearnMoreTag, {
                    url: __("https://devowl.io/knowledge-base/real-cookie-banner-with-google-tag-manager-or-matomo-tag-manager/")
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, curValues)=>prevValues.tagManagerOptInEventName !== curValues.tagManagerOptInEventName || prevValues.tagManagerOptOutEventName !== curValues.tagManagerOptOutEventName,
                children: ({ getFieldValue })=>{
                    const inEventName = getFieldValue("tagManagerOptInEventName");
                    const outEventName = getFieldValue("tagManagerOptOutEventName");
                    return (inEventName.length > 0 || outEventName.length > 0) && !!managerLabel && !createdTagManagers[expectedManagerPresetId].length && /*#__PURE__*/ _jsx(Notices, {
                        notices: [
                            {
                                message: __("You have not yet defined a %s service. To use event names, you must create a %s service.", managerLabel, managerLabel),
                                severity: "warning"
                            }
                        ]
                    });
                }
            })
        ]
    });
};
export { FormServiceFieldHandlingTagManagerEventName };
